import { useEffect } from "react";
import styled from "styled-components";
import { SIMPLE_PROMOTION } from "../WorkSpace/CanvasViewer/EncarteConstants";
import Loading from "./Loading";

export const List = styled.ul`
  gap: 3rem;
  width: 100%;
  position: relative;
`;

export const ProductItem = styled.li`
  align-items: center;
  width: 100%;
  user-select: none;
  justify-content: space-between;
  font-size: 1.4rem;
  font-weight: bold;
  transition: all 300ms ease-in-out;
  cursor: pointer;
  padding: 0 1.2rem;
  &:hover {
    background-color: #d97706;
  }
  span:first-letter {
    text-transform: uppercase;
  }
  img {
    width: 5rem;
    height: 5rem;
  }

  .name-price-wrapper {
    gap: 3rem;
  }

  .no-image-span {
    font-size: 1.2rem;
    width: min-content;
    text-align: center;
  }

  .in-promotion {
    color: #008000;
  }

  .no-promotion {
    color: #ee4b2b;
  }
`;

const ImageWrapper = styled.div`
  position: relative;
  height: 100%;
  width: min-content;
  text-align: center;
`;

export function ListProduct({ product, action, showPromotion = true }) {
  return (
    <ProductItem
      className="flex"
      onClick={() => {
        action(product);
      }}
    >
      <div className="name-price-wrapper flex">
        <span>{product.name}</span>
        <div className="price-unity-wrapper flex direction-column">
          <span className="price">R${product.promotionPrice}</span>
          <span className="unity">{product.measurement}</span>
        </div>
        {showPromotion && (
          <div className="price-unity-wrapper flex direction-column">
            <span className="price">Promoção</span>
            <span className="unity">
              {product.promotionType != SIMPLE_PROMOTION ? (
                <span className="in-promotion">sim</span>
              ) : (
                <span className="no-promotion">não</span>
              )}
            </span>
          </div>
        )}
      </div>
      <ImageWrapper>
        {product.displayUrl != null ? (
          <img src={product.displayUrl} alt="" className="product-image" />
        ) : (
          <span className="no-image-span">Sem imagem</span>
        )}
      </ImageWrapper>
    </ProductItem>
  );
}
